import React, { useReducer } from 'react'

const TYPES = {
  SET_CURRENT_PROFILE: 'profile/SET_CURRENT_PROFILE',
}

const ProfileContext = React.createContext()

export const initialState = {
  currentProfile: null,
}

// This is equivalent to standard reducer's switch-case statement but more condensed, readable and separable
const handlers = {}

handlers[TYPES.SET_CURRENT_PROFILE] = (state, action) => ({
  ...state,
  currentProfile: action.data,
})

// Reducer factory to enable enhanced syntax above
const reducerFactory = (initialState, handlers) => (state = initialState, action) =>
  handlers && handlers[action.type] ? handlers[action.type](state, action) : state

const reducer = reducerFactory(initialState, handlers)

// Provider component which will be used to wrap a group of components in order to pass context variables
const ProfileContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const value = { state, dispatch }

  return <ProfileContext.Provider value={value}>{props.children}</ProfileContext.Provider>
}

export { ProfileContext, ProfileContextProvider }
